import { render, staticRenderFns } from "./layout-web.vue?vue&type=template&id=4e70a4c7"
import script from "./layout-web.vue?vue&type=script&lang=js"
export * from "./layout-web.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports